import { CalendarDays, Users } from 'lucide-react'
import type * as React from 'react'

interface InspectionDetailsHeaderProps {
	title?: React.ReactNode
	date: string
	createdBy?: string
}

const renderText = (value: React.ReactNode | undefined, className: string) => {
	if (!value) return null
	if (typeof value === 'string') {
		return <span className={className}>{value}</span>
	}
	return value
}

export const InspectionDetailsHeader = ({
	title,
	date,
	createdBy,
}: InspectionDetailsHeaderProps) => {
	return (
		<div className="flex items-center justify-between gap-2">
			<div className="flex flex-col gap-1">
				{renderText(title, 'text-base font-semibold text-kaefer-dark-grey')}
			</div>
			<div className="flex flex-col items-end gap-1">
				<span className="flex items-center gap-2 text-sm text-muted-foreground">
					<CalendarDays className="size-4" />
					{date}
				</span>
				{createdBy && (
					<span className="flex items-center gap-2 text-sm text-muted-foreground">
						<Users className="size-4" />
						{createdBy}
					</span>
				)}
			</div>
		</div>
	)
}
